<script setup lang="ts">

import { Backgrounds } from "../Types/Backgrounds";
import { usePresentation } from '@presentation/Types/Presentation';

const presentation = usePresentation();
presentation.isTitleComponent = true;
presentation.backgroundImage = presentation.theme.showImageOnTitlePages ? Backgrounds.One : '';

</script>

<template>

    <Animated :duration="300" animation="slide-down" class="w-full !h-full">
        <div class="w-full !h-full flex flex-col justify-center items-center
                    text-2xl lg:text-6xl font-semibold uppercase">
            <div>
                <h1>{{ presentation.currentSection.title }}</h1>
            </div>
        </div>
    </Animated>

</template>